import { defineAsyncComponent } from 'vue'
export default {
  cabinet: defineAsyncComponent(() => import("/var/www/2025-11-05_17_57/layouts/cabinet.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/2025-11-05_17_57/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/var/www/2025-11-05_17_57/layouts/empty.vue").then(m => m.default || m))
}